import { schema } from 'normalizr';

const StatusSchema = new schema.Entity('statuses', {});

export default StatusSchema;
